// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7940":"f4bce2eb","9114":"f4bce2eb"}[chunkId] + ".chunk.css";
};